import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList } from "@angular/core";
import { UserLayoutService } from "../../layouts/user-layout/user-layout.service";
import { CommonService } from "../../shared/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Swiper } from "swiper";
import { StorageService } from "../../shared/storage.service";
import { DatePipe } from "@angular/common";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { OrganizationEnumModel } from "../../shared/constant/organization.model";
import { Meta, Title } from '@angular/platform-browser';
declare var $: any;

enum Month {
  January = 1,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}

@Component({
  selector: "app-divine-destination",
  templateUrl: "./divine-destination.component.html",
  styleUrls: ["./divine-destination.component.css"],
})
export class DivineDestinationComponent implements OnInit {
  cities: string[] = [];
  pathways: string[] = [];
  filteredCities: string[] = [];
  filteredPathways: string[] = [];
  searchTerm: string = "";
  pathwaySearchTerm: string = "";

  //for filter
  selectedReligion: string = '';
  selectedCity: string[] = [];
  selectedMonth: string = "";
  selectedPathway: string[] = [];

  @ViewChildren('cityCheckbox') cityCheckboxes: QueryList<ElementRef>;
  @ViewChildren('pathwayCheckbox') pathwayCheckboxes: QueryList<ElementRef>;
  @ViewChildren('dayCheckbox') dayCheckboxes: QueryList<ElementRef>;


  festivalId: string = "";
  firstSelectedFilterType: string | null = null;
  packages: any[] = [];
  festivalList: any[] = [];
  cityDetails: any = null;
  pilgrimDetails: any = null;
  selectedFestival: any = null;
  noPackagesMessage: string = "";

  trendingDataList: any = [];

  //day filter
  daysOptions: any[] = [
    { day: '1-3 Days', value: 1 },
    { day: '3-5 Days', value: 3 },
    { day: '5-8 Days', value: 5 },
    { day: 'Greater than 8 Days', value: 8 },
  ];
  selectedDays: any[] = [];
  // Pagination variables
  currentPage: number = 1;
  pageSize: number = 9;
  totalPackages: number = 0;
  totalPages: number = 1;
  showPackages: boolean = false;
  months = Object.keys(Month).filter((key) => isNaN(Number(key)));
  minStartDate: any;
  datePickerConfig: Partial<BsDatepickerConfig>;

  whatsAppInquirySubmitted: boolean = false;
  whatsAppInquiryContact: string = '';
  whatsappInquiryData = {
    adults: 1,
    children: 0,
    startDate: ''
  };

  packageDetail = [
    {
      packageId: '',
      packageName: ''
    }
  ];

  onImageError(event: any) {
    event.target.src = 'assets/images/safenet_logo_new.png';
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public storageService: StorageService,
    public commonService: CommonService,
    private datePipe: DatePipe,
    public userLayoutService: UserLayoutService, private meta: Meta, private title: Title
  ) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
    this.datePickerConfig = {
      containerClass: 'theme-dark-blue',
      dateInputFormat: 'MMM DD, YYYY',
      showWeekNumbers: false
    };
    this.minStartDate = new Date();
    const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));

    const taxAttribute = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.filter_package_size);
    if (taxAttribute && taxAttribute.customValue !== null) {
      this.pageSize = parseInt(taxAttribute.customValue) || 9;
    }
    this.getCities();
    this.getPilgrimPathways();
    // this.setDefaultMonth();
    this.getTrandingPackageList();
    // this.getDaysFilterList();
    this.route.queryParams.subscribe(params => {
      params['rid'] ? this.selectedReligion = params['rid'] : this.selectedReligion = '';
      params['city'] ? this.selectedCity.push(params['city']) : null;
    });
    this.showPackages = true;
    if (this.selectedReligion || this.selectedCity.length > 0) {
      this.showPackages = true;
    }
    this.fetchFilterValues();
    this.getDivineDestinationSearch();
  }
  metaTagAdd() {
    this.title.setTitle('Temple Tour Packages India | Char Dham Yatra Packages');

    this.meta.updateTag({
      name: 'description',
      content: 'Looking for Char Dham Complete Tour Itinerary with All Transport, Multilingual Shirdi Nashik Pilgrimage Package, Tirupati Temple Tour Packages, Varanasi Bodhgaya Spiritual Group Tour, Shirdi Nashik Spiritual Tours and Custom 10 Day Spiritual Tour Bihar Gaya Bodh Gaya then contact My Yatra360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'Varanasi Bodhgaya Spiritual Group Tour, Custom 10 Day Spiritual Tour Bihar Gaya Bodh Gaya, Tirupati Temple Tour Packages, Shirdi Nashik Spiritual Tours, Multilingual Shirdi Nashik Pilgrimage Package, Char Dham Yatra Packages, Char Dham Complete Tour, Char Dham Complete Itinerary with All Transport, Temple Tour Packages India'
    });
  }
  ngAfterViewInit(): void {
    setInterval(() => {
      // add section
      $('.addscloseicon').click(function () {
        $('.adds_section').css('right', '-100%');
        $('.open_add_section').css({
          'right': '0',
          'delay': '0.5s',
        });

      });
      $('.open_add_section').click(function () {
        $('.adds_section').css({

          'right': '0',
          'transition': 'all 0.5s ease',
          'delay': '0.5s',
        });
        $('.open_add_section').css({
          'right': '-100%',
          'delay': '0.5s',
        });

      });

    }, 200);
  }
  togglePackages() {
    this.showPackages = !this.showPackages;
    window.scrollTo(0, 0);
  }

  getCities() {
    this.userLayoutService.getCitiesName().subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.cities = res.data;
          this.filteredCities = [...this.cities];
          this.filterCities();
        } else {
          console.warn("No cities found");
        }
      },
      (error) => console.error("Error fetching cities:", error.error.Message)
    );
  }


  getDaysFilterList() {
    this.userLayoutService.GetDaysFilterList().subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.daysOptions = res.data;
        } else {
          console.warn("No Days found");
        }
      },
      (error) => console.error("Error fetching Days:", error.error.Message)
    );
  }

  getTrandingPackageList() {
    this.userLayoutService.getTrandingPackageData().subscribe((Response: any) => {

      if (Response.code == 1) {
        this.trendingDataList = Response.data[0].packages.map((pkg: any) => {
          const match = pkg.numberOfDaysAndNight.match(/(\d+)\s*Days\s*(\d+)\s*Nights/i);
          return {
            ...pkg,
            totalDay: match ? parseInt(match[1], 10) : null,
            totalNight: match ? parseInt(match[2], 10) : null,
          };
        });
        // console.log("Tranding Package places", this.trendingDataList);
      }
      else {
        this.router.navigate(['home']);
      }
    }, (error) => {
      // console.log(error.error.Message);
      this.router.navigate(['home']);
    });
  }

  packageDetails(packageId: any) {
    this.router.navigate(["packages-details"], {
      queryParams: { PackageId: packageId },
    });
  }

  getPilgrimPathways() {
    this.userLayoutService.GetPilgrimPathwaysName().subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.pathways = res.data;
          this.filteredPathways = [...this.pathways];
        } else {
          console.warn("No Pilgrim Pathways found");
        }
      },
      (error) =>
        console.error("Error fetching Pilgrim Pathways:", error.error.Message)
    );
  }

  onSearchChange() {
    this.filterCities();
  }

  filterCities() {
    this.filteredCities = this.searchTerm
      ? this.cities.filter((city: any) =>
        city?.name?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
      : [...this.cities];
  }

  onPathwaySearchChange() {
    this.filteredPathways = this.pathwaySearchTerm
      ? this.pathways.filter((pathway) =>
        pathway.toLowerCase().includes(this.pathwaySearchTerm.toLowerCase())
      )
      : [...this.pathways];
  }

  fetchFilterValues() {
    this.selectedCity = JSON.parse(localStorage.getItem('selectedCity')) || this.selectedCity;
    this.pathways = JSON.parse(localStorage.getItem('pathways')) || this.pathways;
    this.selectedPathway = JSON.parse(localStorage.getItem('selectedPathway')) || this.selectedPathway;
    this.festivalId = localStorage.getItem('festivalId') || this.festivalId;
    this.selectedDays = JSON.parse(localStorage.getItem('selectedDays')) || this.selectedDays;
    this.selectedReligion = JSON.parse(localStorage.getItem('selectedReligion')) || this.selectedReligion;
    this.daysOptions = JSON.parse(localStorage.getItem('daysOptions')) || this.daysOptions;
    this.filteredCities = [...this.cities];
    this.filteredPathways = [...this.pathways];


    if (this.selectedReligion) {
      this.router.navigate([], {
        queryParams: { 'rid': this.selectedReligion },
        queryParamsHandling: 'merge',
      });
    }
  }

  storeFilterValues() {
    localStorage.setItem('selectedCity', JSON.stringify(this.selectedCity));
    localStorage.setItem('pathways', JSON.stringify(this.pathways));
    localStorage.setItem('selectedPathway', JSON.stringify(this.selectedPathway));
    localStorage.setItem('festivalId', this.festivalId || '');
    localStorage.setItem('daysOptions', JSON.stringify(this.daysOptions));
    localStorage.setItem('selectedDays', JSON.stringify(this.selectedDays));
    localStorage.setItem('selectedReligion', JSON.stringify(this.selectedReligion));
  }

  getDivineDestinationSearch() {
    // const monthValue = this.selectedMonth
    //   ? Month[this.selectedMonth as keyof typeof Month].toString()
    //   : "";
    this.storeFilterValues();

    const cityValue = this.selectedCity.join(',');
    const pathwayValue = this.selectedPathway.join(',');
    const festivalIdValue = this.festivalId || "";
    const daysValue = this.selectedDays.join(',');
    const religionList = this.selectedReligion;

    // console.log('API City Value:', cityValue);
    // console.log('API Pathway Value:', pathwayValue);
    // console.log('API Days Value:', daysValue);

    let paramsObj = {
      City: cityValue,
      Days: daysValue,
      //monthValue,
      PilgrimPathway: pathwayValue,
      FestivalId: festivalIdValue,
      GodList: religionList,
      PageNumber: this.currentPage,
      PageSize: this.pageSize
    }

    this.userLayoutService
      .getDivineDestinationSearch(paramsObj).subscribe(
        (res: any) => {
          if (res.code === 1) {
            this.packages = res.data.packages.map((pkg: any) => {
              const match = pkg.numberOfDaysAndNight?.match(/(\d+)\s*Days\s*(\d+)\s*Nights/i);
              return {
                ...pkg,
                totalDay: match ? parseInt(match[1], 10) : null,
                totalNight: match ? parseInt(match[2], 10) : null,
              };
            });
            this.festivalList = res.data.festivals || [];
            this.cityDetails = res.data.cityDetails || null;
            this.pilgrimDetails = res.data.pilgrimDetails || null;

            // Fix total pages calculation
            this.totalPackages = res.data.totalRecords || 0;
            this.totalPages = Math.ceil(this.totalPackages / this.pageSize);

            // Ensure currentPage does not exceed totalPages
            if (this.currentPage > this.totalPages) {
              if (this.totalPages > 0) {
                this.currentPage = this.totalPages;
              }
              else {
                this.currentPage = 1;
                this.totalPages = 1;
              }
            }

            this.noPackagesMessage =
              this.packages.length === 0 ? "No packages available." : "";

            if (this.selectedMonth && this.festivalList.length > 0 && !this.selectedFestival) {
              this.selectedFestival = this.festivalList[0];
              this.festivalId = this.selectedFestival.id;
            }
          } else {
            this.packages = [];
            this.festivalList = [];
            this.cityDetails = null;
            this.pilgrimDetails = null;
            this.selectedFestival = null;
            this.totalPackages = 0;
            this.totalPages = 1;
            this.noPackagesMessage = "No packages available.";
          }
        },
        (error) => {
          console.error("Error fetching packages:", error);
          this.packages = [];
          this.festivalList = [];
          this.cityDetails = null;
          this.pilgrimDetails = null;
          this.selectedFestival = null;
          this.totalPackages = 0;
          this.totalPages = 1;
          this.noPackagesMessage =
            "Error retrieving packages. Please try again later.";
        }
      );
    window.scrollTo(0, 0);
  }

  // Pagination methods
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getDivineDestinationSearch();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getDivineDestinationSearch();
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.getDivineDestinationSearch();
    }
  }

  clearFilters() {
    this.selectedCity = [];
    this.selectedPathway = [];
    this.selectedDays = [];
    this.selectedMonth = "";
    this.festivalId = "";
    this.selectedFestival = null;
    this.searchTerm = "";
    this.filteredCities = [...this.cities];
    this.firstSelectedFilterType = null;
    this.currentPage = 1;
    this.selectedReligion = "";

    // Remove query params
    this.router.navigate([], {
      queryParams: { 'rid': null, 'city': null },
      queryParamsHandling: 'merge',
    });
    // Uncheck city checkboxes
    if (this.cityCheckboxes) {
      this.cityCheckboxes.forEach((checkbox) => {
        checkbox.nativeElement.checked = false;
      });
    }

    // Uncheck pathway checkboxes
    if (this.pathwayCheckboxes) {
      this.pathwayCheckboxes.forEach((checkbox) => {
        checkbox.nativeElement.checked = false;
      });
    }

    // Uncheck day checkboxes
    if (this.dayCheckboxes) {
      this.dayCheckboxes.forEach((checkbox) => {
        checkbox.nativeElement.checked = false;
      });
    }

    this.getDivineDestinationSearch();
    window.scrollTo(0, 0);
  }

  // selectCity(city: string) {
  //   if (this.selectedCity === city) {
  //     this.selectedCity = ""; // Deselect if already selected
  //   } else {
  //     this.selectedCity = city;
  //   }

  //   this.currentPage = 1;
  //   this.getDivineDestinationSearch();
  // }

  // selectMonth(month: string) {
  //   if (this.selectedMonth === month) {
  //     this.selectedMonth = ""; // Deselect if already selected
  //   } else {
  //     this.selectedMonth = month;
  //   }

  //   this.currentPage = 1;
  //   this.getDivineDestinationSearch();
  // }

  // selectPathway(pathway: string) {
  //   if (this.selectedPathway === pathway) {
  //     this.selectedPathway = ""; // Deselect if already selected
  //   } else {
  //     this.selectedPathway = pathway;
  //   }
  //   this.currentPage = 1;
  //   this.getDivineDestinationSearch();
  // }

  // selectFestival(event: Event, festival: any) {
  //   event.preventDefault();
  //   this.selectedFestival = festival;
  //   this.festivalId = festival.id;
  //   this.getDivineDestinationSearch();
  // }

  onDayChange(day: string, event: any) {
    if (this.selectedReligion) {
      this.clearReligionPath()
    }
    if (event.target.checked) {
      this.selectedDays.push(day);
    } else {
      const index = this.selectedDays.indexOf(day);
      if (index > -1) {
        this.selectedDays.splice(index, 1);
      }
    }
    this.currentPage = 1;
    this.getDivineDestinationSearch();
  }

  onMonthChange(month: string) {
    this.selectedMonth = month;
    this.updateFirstSelectedFilter("month");
    this.currentPage = 1;
    this.getDivineDestinationSearch();
    //window.scrollTo(100, 160);
  }

  onCityChange(city: string, event: any) {
    if (this.selectedReligion) {
      this.clearReligionPath()
    }
    if (event.target.checked) {
      this.selectedCity.push(city);
    } else {
      const index = this.selectedCity.indexOf(city);
      if (index > -1) {
        this.selectedCity.splice(index, 1);
      }
    }
    this.updateFirstSelectedFilter("city");
    this.currentPage = 1;
    this.getDivineDestinationSearch();
    //window.scrollTo(100, 160);
  }

  onPathwayChange(pathway: string, event: any) {
    if (this.selectedReligion) {
      this.clearReligionPath()
    }
    if (event.target.checked) {
      this.selectedPathway.push(pathway);
    } else {
      const index = this.selectedPathway.indexOf(pathway);
      if (index > -1) {
        this.selectedPathway.splice(index, 1);
      }
    }
    this.updateFirstSelectedFilter("pathway");
    this.currentPage = 1;
    this.getDivineDestinationSearch();
    //window.scrollTo(100, 160);
  }

  updateFirstSelectedFilter(type: string) {
    if (!this.firstSelectedFilterType) {
      this.firstSelectedFilterType = type;
    }
  }

  clearReligionPath() {
    this.selectedReligion = "";

    // Remove query params
    this.router.navigate([], {
      queryParams: { 'rid': null },
      queryParamsHandling: 'merge',
    });
  }

  openWhatsAppInquiry(packageid: string, packageName: string) {
    this.packageDetail = []
    this.whatsAppInquirySubmitted = false;
    this.whatsappInquiryData = {
      adults: 1,
      children: 0,
      startDate: ''
    };
    this.packageDetail = [
      {
        packageId: packageid,
        packageName: packageName
      }
    ];
    $('#whatsAppData').modal('show');

  }

  AddWhatsappInquiry() {
    this.whatsAppInquirySubmitted = true;
    let { adults, children, startDate } = this.whatsappInquiryData;
    if (adults > 0 && startDate) {
      // Extract package info
      const packageData = this.packageDetail[0];
      const packageName = packageData.packageName;
      const packageId = packageData.packageId;
      startDate = this.datePipe.transform(startDate, 'dd MMMM, yyyy');

      // Build message
      const totalTravelers = `${adults} Adult${adults !== 1 ? 's' : ''}` +
        (children > 0 ? ` & ${children} Child${children > 1 ? 'ren' : ''}` : '');

      const message = `I am interested in the ${packageName} Package.\n\n` +
        `Starting Date: ${startDate}\n` +
        `Travelers: ${totalTravelers}\n\n` +
        `Package Details:\nhttps://myyatra360.com/packages-details?PackageId=${packageId}`;

      //--------------------------------Whatsapp No.------------------------------------//
      const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
      if (localStorage.currencyCode == 'INR') {
        this.whatsAppInquiryContact = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.indiaWhastAppNo && attr.value == true)?.customValue
      }
      else {
        this.whatsAppInquiryContact = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.globalWhastAppNo && attr.value == true)?.customValue
      }
      const phoneNumber = this.whatsAppInquiryContact;
      //--------------------------------Whatsapp No.------------------------------------//

      //   const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

      $('#whatsAppData').modal('hide');
      window.open(whatsappURL, '_blank');
    } else {
      return;
    }
  }
}
